<script lang="ts">
    import type { HTMLAttributes } from "svelte/elements";
    import { locale } from "../../locale.svelte.js";
    import Unreachable from "./unreachable.svelte";
    import Throw from "./throw.svelte";
    import { type BigNumber } from "@repo/utils";

    const {
        value = $bindable(),
        options,
        ...htmlAttributes
    }: {
        value: BigNumber;
        options?: Intl.NumberFormatOptions;
    } & HTMLAttributes<HTMLSpanElement> = $props();
    const formatter = $derived(new Intl.NumberFormat(locale.current, { maximumFractionDigits: 100, ...options }));
    const parts = $derived(formatter.formatToParts(value.toNumber()));
</script>

<span class="tabular-nums" {...htmlAttributes}>
    {#each parts as x, i (i)}
        {#if x.type === "currency" || x.type === "minusSign" || x.type === "plusSign" || x.type === "literal" || x.type === "decimal" || x.type === "fraction" || x.type === "integer" || x.type === "unit" || x.type === "percent" || x.type === "percentSign"}
            {x.value}
        {:else if x.type === "group"}
            <span class="select-none" aria-hidden="true" role="presentation">{x.value}</span>
        {:else if x.type === "unknown" || x.type === "exponentInteger" || x.type === "exponentMinusSign" || x.type === "nan" || x.type === "infinity" || x.type === "exponentSeparator" || x.type === "compact"}
            <Throw error={new Error(`Unsupported number part ${x.type}`)} />
        {:else}
            <Unreachable value={x.type} />
        {/if}
    {/each}
</span>
